"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { Wrench } from "lucide-react";
import { useChainStatus } from "@/features/blockchain-status/store";
import "./maintenance-notice.css";

/**
 * THE SITE-WIDE NOTICE while the chain is down — on every page, in the page's language, shown
 * only when `GET /blockchain-status` says `available: false` (or cannot be reached). The words
 * are the backend's; the line below is only for when the backend could not be asked at all.
 *
 * It is also what asks: once when the app loads, and again when the tab comes back after the
 * backend's five-minute cache has turned over. Blockchain actions read the same status
 * (`ActionButton chain`) and stay off while it is down.
 */
const UNREACHABLE_COPY = {
  fa: "در حال حاضر ثبت تراکنش، خرید و فروش و ساخت اثر امکان‌پذیر نیست. لطفاً کمی بعد دوباره سر بزنید.",
  en: "Transactions, buying, selling and creating works are unavailable right now. Please check back a little later."
} as const;
export default function MaintenanceNotice(t0) {
  const $ = _c(9);
  const {
    lang
  } = t0;
  const available = useChainStatus(_temp);
  const message = useChainStatus(_temp2);
  const check = useChainStatus(_temp3);
  let t1;
  let t2;
  if ($[0] !== check) {
    t1 = () => {
      check();
      const again = () => {
        if (document.visibilityState === "visible") {
          check();
        }
      };
      document.addEventListener("visibilitychange", again);
      return () => document.removeEventListener("visibilitychange", again);
    };
    t2 = [check];
    $[0] = check;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (available) {
    return null;
  }
  const t3 = lang === "fa" ? "rtl" : "ltr";
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Wrench aria-hidden={true} />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = message ? message[lang] : UNREACHABLE_COPY[lang];
  let t6;
  if ($[4] !== t5) {
    t6 = <p>{t5}</p>;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t3 || $[7] !== t6) {
    t7 = <div className="v2 v2-notice" role="status" dir={t3}>{t4}{t6}</div>;
    $[6] = t3;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
}
function _temp3(s_1) {
  return s_1.check;
}
function _temp2(s_0) {
  return s_0.message;
}
function _temp(s) {
  return s.available;
}